import { render, staticRenderFns } from "./ProductManageDetail.vue?vue&type=template&id=e067f72c&scoped=true"
import script from "./ProductManageDetail.vue?vue&type=script&lang=js"
export * from "./ProductManageDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductManageDetail.vue?vue&type=style&index=0&id=e067f72c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e067f72c",
  null
  
)

export default component.exports